import { downloadFileFromUrl } from "@frontend/utils";

/**
 * Handler for the download_last_image tool-call.
 * It finds the most recent assistant message with an image attachment and triggers a download.
 */
export const handleDownloadLastImage = async (response, { state, commit, dispatch } = {}) => {
  const messages = [...state.messages].reverse();
  let foundAttachment = null;

  for (const msg of messages) {
    if (msg.role === 'assistant' && msg.attachments && msg.attachments.length) {
      // Find the first attachment of type 'url' (image/file link)
      foundAttachment = msg.attachments.find(att => att.type === 'url');
      if (foundAttachment) break;
    }
  }

  if (foundAttachment) {
    const url = foundAttachment.payload;
    const fileName = foundAttachment.name || 'downloaded-image';
    
    // Trigger download using the shared utility
    await downloadFileFromUrl(url, fileName);

    dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: `I've started the download. Check your downloads folder!`
    });

    return { 
      success: true, 
      message: "The image download has been triggered." 
    };
  }

  dispatch('addAndSaveMessage', {
    role: 'assistant',
    content: "I couldn't find any images in the chat history to download."
  });

  return { 
    success: false, 
    message: "No image found in the chat history to download." 
  };
};
